<template>
<div class="expression">
  <button @click="remove" class="delete"></button>
  <span style="display: none;">{{ computedExpression }}</span>
  <div class="field is-horizontal">
    <div class="field-body">
      <auto-complete-input
        :def="def"
        :expression.sync="leftExpression">
      </auto-complete-input>
    </div>
  </div>

  <div class="field is-horizontal middle-field">
    <div class="field-body">

      <div class="field is-narrow">
        <div class="control">
          <multiselect
            v-model="selectedFieldComparison"
            :options="operators"
            :show-labels="false"
            :close-on-select="true"
            :clear-on-select="true"
            :hide-selected="false"
            :allow-empty="false"
            placeholder="Select an operator">
          </multiselect>
        </div>
      </div>

      <div
        class="field is-narrow">
        <multiselect
          v-model="selectedStringOptions"
          :options="stringOptions"
          :show-labels="false"
          :close-on-select="true"
          :clear-on-select="true"
          :hide-selected="false"
          :allow-empty="false"
          placeholder="">
        </multiselect>
      </div>

    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-body">
      <div class="field">
        <p class="control is-expanded">
          <input
            v-model="selectedFieldValue"
            @change="updateExpression"
            class="input">
        </p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import AutoCompleteInput from '@/components/analytics/editor/AutoCompleteInput.vue';

export default {
  name: 'QueryBuilderExpression',
  components: {
    AutoCompleteInput,
    Multiselect,
  },
  props: {
    depth: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    fieldPrepend: {
      type: String,
      required: true,
    },
    def: {
      type: Object,
      required: true,
    },
    expression: {
      type: String,
      required: true,
    },
  },
  watch: {
    computedExpression() {
      this.$emit('update:expression', this.computedExpression);
    },
  },
  computed: {
    processedField() {
      return `${this.fieldPrepend}${this.selectedField}`;
    },
    processedValue() {
      return `${this.selectedFieldValue}`;
    },
    processStringOptions() {
      if (this.selectedStringOptions !== '') {
        return `[${this.selectedStringOptions}]`;
      }
      return '';
    },
    computedExpression() {
      let expression = '';
      expression = `${this.leftExpression}`;
      if (this.selectedFieldComparison) {
        expression = `${expression} ${this.selectedFieldComparison}`;
      }
      if (this.processStringOptions) {
        expression = `${expression}${this.processStringOptions}`;
      }
      if (this.processedValue) {
        expression = `${expression} ${this.processedValue}`;
      }
      this.$emit('update:expression', expression);
      return expression;
    },
  },
  data() {
    return {
      leftExpression: '',
      selectedFieldObject: null,
      selectedField: null,
      selectedFieldComparison: null,
      selectedFieldValue: '',
      selectedStringOptions: '',
      stringOptions: [
        '',
        'c',
        'd',
        'cd',
      ],
      operators: [
        'CONTAINS',
        'IN',
        'BEGINSWITH',
        'ENDSWITH',
        'LIKE',
        'MATCHES',
        '==',
        '!=',
        '>',
        '<',
        '>=',
        '<=',
      ],
    };
  },
  methods: {
    remove() {
      this.$emit('child-deletion-requested', this.index);
    },
    updateExpression() { },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

$spacing: 10px;

.middle-field {
  margin: $spacing 0;
}

.expression {
  background: $expression-background;
  padding: 1.5rem 2rem;
  border-radius: 0px;
  position: relative;
  margin-bottom: 5px;

  button.delete {
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
  }
}
</style>
